import './styles.scss';
import { SITE_URL } from '@/constants/constants';
const LoadingSubscriptionModal = () => import('../../components/loading-subscription-modal/index.vue');
const EulaModal = () => import('../../components/eula-modal/index.vue');
const PrivacyPolicyModal = () => import('../../components/privacy-policy/index.vue');


export default {
    name: 'LoginPage',
    
    data() {
        return {
            email: '',
            password: '',
            subscriptions: null,
            loginAlert: null,
            allowLogin: true,
            base_url: SITE_URL
        }
    },

    created() {
        this.$store.dispatch('checkAuthorization').then(() => {
            this.$router.push({ path: '/action' });
        });
    },

    methods: {

       async showEula() {
            const eulaModal = await this.$ionic.modalController.create({
                component: EulaModal,
                backdropDismiss: false
            });

            eulaModal.present();
        },

        async showPrivacyPolicy() {
            const privacyPolicyModal = await this.$ionic.modalController.create({
                component: PrivacyPolicyModal,
                backdropDismiss: false
            });

            privacyPolicyModal.present();
        },

        async checkEula() {
            window.alert(this.allowLogin);
        },

        async authenticate() {
            if (this.email && this.password) {
                if (!this.$store.state.online_status) {
                    this.$ionic.alertController.create({
                        header: 'Cannot Login',
                        message: 'Please restore your internet connection and try again.',
                        buttons: ['OK'],
                    }).then(a => a.present());
                } else {

                    this.loginAlert = await this.$ionic.loadingController.create({
                        spinner: 'lines',
                        animated: true,
                        message: 'Signing In',
                        translucent: false,
                    });

                    this.loginAlert.present();

                    let auth = btoa(this.email + ':' + this.password);
                    let headers = { 'Authorization': `Basic ${auth}` };
                    this.$store.commit('setLastBuild', this.$store.state.currentBuild); 
                    this.$store.dispatch('fetchSubscriptions', headers).then((response) => {
                        this.loginAlert.dismiss(); 
                        
                        let subscriptions = response.data;
                        let inputs = [];

                        subscriptions.forEach((item, index) => {
                            let input = {
                                type: 'radio',
                                label: item.name,
                                value: item,
                                checked: index === 0
                            };
                            inputs.push(input);
                        });

                        this.$ionic.alertController.create({
                            header: 'Choose a Building',
                            cssClass: 'subscription-selection',
                            inputs: inputs,
                            buttons: [
                                {
                                    text: 'Select',
                                    handler: (data) => {
                                        this.$store.commit('setActiveSubscription', data);
                                        this.$ionic.modalController.create({
                                            component: LoadingSubscriptionModal,
                                            backdropDismiss: false
                                        }).then(async (modal) =>  {
                                            modal.present();
                                            await this.$store.dispatch('fetchInitialData');
                                            modal.dismiss();
                                            this.$router.push({ path: 'action' });
                                        });
                                    },
                                },
                            ],
                        }).then(a => a.present());
                    }).catch((error) => {
                        console.info("Ligin failed");
                        this.loginAlert.dismiss();
                        this.$ionic.alertController.create({
                            header: 'Cannot Login',
                            message: 'Please verify your login information and try again.',
                            buttons: ['OK'],
                        }).then(a => a.present());
                    });
                }
            } else {
                let message = 'Please enter your ';

                if (!this.email && !this.password) {
                    message += 'email and password.';
                } else if (!this.email) {
                    message += 'email address.';
                } else {
                    message += 'password';
                }

                this.$ionic.alertController.create({
                    header: 'Error',
                    message: message,
                    buttons: ['OK'],
                }).then(a => a.present());
            }
        }
    }
};